var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F9ECFE",
    fillRule: "nonzero",
    cx: 36,
    cy: 36,
    r: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.298 37.255h1.965s1.668-3.457 2.386-4.125c2.316-2.152 2.699-4.69 3.825-6.915.3-.592.456-1.247.456-1.912 0 0-.08-1.402 0-1.86.677-3.875 5.474-2.345 5.193 1.87-.222 3.337-1.684 6.968-1.474 7.466.21.498 12.632-2.65 10.807 4.196 1.685.498 1.754 5.1-.631 5.546 1.684 1.21.772 3.983-.842 4.267.771 1.28 1.052 4.551-2.808 4.765-3.86.213-19.438-.427-19.438-.427l.561-12.871z",
    fill: "#CA8BEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.085 51.833H21.67a1.47 1.47 0 0 1-1.46-1.48V35.393c0-.818.654-1.48 1.46-1.48h6.415c.805 0 1.459.662 1.459 1.48v14.962a1.47 1.47 0 0 1-1.46 1.479z",
    fill: "#830AC5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.877 37.593c0 .618-.495 1.12-1.105 1.12s-1.105-.502-1.105-1.12c0-.619.495-1.12 1.105-1.12s1.105.501 1.105 1.12z",
    fill: "#CA8BEC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocial);
export default __webpack_public_path__ + "static/media/ic_social.b49d8e335883fa70814701903c0a6d7f.svg";
export { ForwardRef as ReactComponent };